var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSkillsIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 46,
    viewBox: "0 0 48 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.72 32.15H43.44V34.43H38.865V39.005H34.29V43.58H32.01V45.86H48V43.58H45.72V32.15Z",
    fill: "#474350"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7199 7.01001H43.4399V11.57H45.7199V7.01001Z",
    fill: "#474350"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.44 29.855H41.145V32.15H43.44V29.855Z",
    fill: "#474350"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.44 11.57H41.145V13.865H43.44V11.57Z",
    fill: "#474350"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43.44 4.71503H41.145V7.01003H43.44V4.71503Z",
    fill: "#474350"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M41.145 13.865H38.865V16.145H41.145V13.865Z",
    fill: "#474350"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M41.145 2.435H38.865V4.715H41.145V2.435Z",
    fill: "#474350"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M38.865 16.145H36.585V18.44H38.865V16.145Z",
    fill: "#474350"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M38.865 11.57H36.585V13.865H38.865V11.57Z",
    fill: "#474350"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M38.865 0.140015H34.29V2.43501H38.865V0.140015Z",
    fill: "#474350"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M41.145 27.575H34.29V29.855H41.145V27.575Z",
    fill: "#474350"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M36.585 18.44H34.29V20.72H36.585V18.44Z",
    fill: "#474350"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M36.585 9.29004H34.29V11.57H36.585V9.29004Z",
    fill: "#474350"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M34.29 29.855H32.01V32.15H34.29V29.855Z",
    fill: "#474350"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M34.29 25.295H32.01V27.575H34.29V25.295Z",
    fill: "#474350"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M34.29 20.72H32.01V23H34.29V20.72Z",
    fill: "#474350"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M34.29 11.57H32.01V13.865H34.29V11.57Z",
    fill: "#474350"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M34.29 7.01001H32.01V9.29001H34.29V7.01001Z",
    fill: "#474350"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M34.29 2.435H32.01V4.715H34.29V2.435Z",
    fill: "#474350"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0101 41.285H29.7151V43.58H32.0101V41.285Z",
    fill: "#474350"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0101 32.15H29.7151V34.43H32.0101V32.15Z",
    fill: "#474350"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0101 23H29.7151V25.295H32.0101V23Z",
    fill: "#474350"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0101 13.865H29.7151V16.145H32.0101V13.865Z",
    fill: "#474350"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0101 4.71503H29.7151V7.01003H32.0101V4.71503Z",
    fill: "#474350"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7151 34.43H27.4351V41.285H29.7151V34.43Z",
    fill: "#474350"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7151 25.295H27.4351V27.575H29.7151V25.295Z",
    fill: "#474350"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7151 16.145H27.4351V18.44H29.7151V16.145Z",
    fill: "#474350"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7151 7.01001H27.4351V9.29001H29.7151V7.01001Z",
    fill: "#474350"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M27.435 32.15H25.155V34.43H27.435V32.15Z",
    fill: "#474350"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M27.435 27.575H25.155V29.855H27.435V27.575Z",
    fill: "#474350"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M27.435 18.44H25.155V20.72H27.435V18.44Z",
    fill: "#474350"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M27.435 9.29004H25.155V11.57H27.435V9.29004Z",
    fill: "#474350"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1551 29.855H22.8601V32.15H25.1551V29.855Z",
    fill: "#474350"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1551 20.72H22.8601V23H25.1551V20.72Z",
    fill: "#474350"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1551 11.57H22.8601V13.865H25.1551V11.57Z",
    fill: "#474350"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8601 32.15H20.5801V34.43H22.8601V32.15Z",
    fill: "#474350"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8601 23H20.5801V25.295H22.8601V23Z",
    fill: "#474350"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8601 13.865H20.5801V16.145H22.8601V13.865Z",
    fill: "#474350"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M20.58 34.43H18.3V36.725H20.58V34.43Z",
    fill: "#474350"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M20.58 25.295H18.3V27.575H20.58V25.295Z",
    fill: "#474350"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M20.58 16.145H18.3V18.44H20.58V16.145Z",
    fill: "#474350"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M20.58 11.57H18.3V13.865H20.58V11.57Z",
    fill: "#474350"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2999 36.725H16.0049V39.005H18.2999V36.725Z",
    fill: "#474350"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2999 27.575H16.0049V29.855H18.2999V27.575Z",
    fill: "#474350"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2999 18.44H16.0049V20.72H18.2999V18.44Z",
    fill: "#474350"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2999 9.29004H16.0049V11.57H18.2999V9.29004Z",
    fill: "#474350"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0051 39.005H13.7251V41.285H16.0051V39.005Z",
    fill: "#474350"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0051 29.855H13.7251V32.15H16.0051V29.855Z",
    fill: "#474350"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0051 20.72H13.7251V23H16.0051V20.72Z",
    fill: "#474350"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0051 7.01001H13.7251V9.29001H16.0051V7.01001Z",
    fill: "#474350"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7249 41.285H11.4299V43.58H13.7249V41.285Z",
    fill: "#474350"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7249 32.15H11.4299V34.43H13.7249V32.15Z",
    fill: "#474350"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7249 23H11.4299V25.295H13.7249V23Z",
    fill: "#474350"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7249 18.44H11.4299V20.72H13.7249V18.44Z",
    fill: "#474350"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7249 4.71503H11.4299V7.01003H13.7249V4.71503Z",
    fill: "#474350"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4299 39.005H9.1499V41.285H11.4299V39.005Z",
    fill: "#474350"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4299 34.43H9.1499V36.725H11.4299V34.43Z",
    fill: "#474350"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4299 25.295H9.1499V27.575H11.4299V25.295Z",
    fill: "#474350"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4299 16.145H9.1499V18.44H11.4299V16.145Z",
    fill: "#474350"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4299 2.435H9.1499V4.715H11.4299V2.435Z",
    fill: "#474350"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M6.87 41.285H4.575V39.005H2.295V34.43H0V45.86H11.43V43.58H6.87V41.285Z",
    fill: "#474350"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M9.15012 36.725H6.87012V39.005H9.15012V36.725Z",
    fill: "#474350"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M9.15012 27.575H6.87012V29.855H9.15012V27.575Z",
    fill: "#474350"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M9.15012 13.865H6.87012V16.145H9.15012V13.865Z",
    fill: "#474350"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M9.14995 0.140015H4.57495V2.43501H9.14995V0.140015Z",
    fill: "#474350"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M6.86995 34.43H4.57495V36.725H6.86995V34.43Z",
    fill: "#474350"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M6.86995 29.855H4.57495V32.15H6.86995V29.855Z",
    fill: "#474350"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M6.86995 11.57H4.57495V13.865H6.86995V11.57Z",
    fill: "#474350"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M4.57492 32.15H2.29492V34.43H4.57492V32.15Z",
    fill: "#474350"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M4.57492 9.29004H2.29492V11.57H4.57492V9.29004Z",
    fill: "#474350"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M4.57492 2.435H2.29492V4.715H4.57492V2.435Z",
    fill: "#474350"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M2.295 4.71503H0V9.29003H2.295V4.71503Z",
    fill: "#474350"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkillsIcon);
export default __webpack_public_path__ + "static/media/skills_icon.fcf4900553a53282e44c346c4d609824.svg";
export { ForwardRef as ReactComponent };